import { getAuth0LogoutGeneration, isAuth0LogoutInFlight } from '@libs/core';

type ClearSdkSessionAfterInterruptedLogoutInput = Readonly<{
    logoutGenerationAtStart: number;
    clearAuth0SdkSession: () => Promise<void>;
    reportError: (error: unknown) => void;
}>;

/** Returns whether logout interrupted the request, even if SDK cleanup fails. */
export async function clearSdkSessionAfterInterruptedLogout({
    logoutGenerationAtStart,
    clearAuth0SdkSession,
    reportError,
}: ClearSdkSessionAfterInterruptedLogoutInput): Promise<boolean> {
    if (getAuth0LogoutGeneration() === logoutGenerationAtStart && !isAuth0LogoutInFlight()) {
        return false;
    }

    // Auth0 caches tokens before its request resolves. Clear that late SDK write
    // when logout interrupted the request; skipping the access cookie is too late.
    try {
        await clearAuth0SdkSession();
    } catch (error) {
        reportError(error);
    }
    return true;
}
